// import * from { class };
import './_instantdefinitions';

import './header';
import './subnav';
import './upcoming';
import './directory';
import './search';
import './glossary';
import './accordion';
import './degrees';
import './tabs';

document.querySelectorAll('.ilink[href="#"]')?.forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
    });
});

var vfeed;
var hours = 0;
var hideHours = 8;
var rssfeed = "";

feednami.setPublicApiKey('bb15aa3b12d47a55a2c315310babf832273e7c398f919da5c9bd0634abd5f401');
var url = 'http://content.getrave.com/rss/ferrum/channel2';

feednami.loadGoogleFormat(url, function (result) {
    
    if (result.error) {
        console.log(result.error)
    }
    else {
        vfeed = result.feed;

        rssfeed += "<p class=\"rss-title\">" + result.feed.title + "</p>";
        // rssfeed+= "<ul class=\"rss-items\">";
        var entries = result.feed.entries
        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            //Start li
            // rssfeed+= "<li class=\"rss-item\">";
            rssfeed += "<p class=\"rss-item\">" + entry.content + "</p>";
            //end Li
            // rssfeed+= "</li><br>"; 

            var pubDate = entry.publishedDate;
            var date = new Date(pubDate);
            var date2 = new Date();
            hours = Math.abs(date - date2) / 36e5;
        }
        // rssfeed+= "</ul>";

        console.log({ hours, hideHours });

        if (hours < hideHours) {

            var rssBox = document.createElement("div");
            rssBox.id = "rss-box";
            rssBox.innerHTML = rssfeed;
            document.body.insertBefore(rssBox, document.body.firstChild);
        }
    }
})